import React, { useState } from 'react';
import RequestDayList from './RequestDayList';
import { formatTime, mailtoAddress } from './requestFormat';
import './ContactRequestList.css';

// DJB-267/279: Contact Requests on the same year › month › day tree as Song
// Requests — no match panel (a contact request has nothing to match). The
// card shows subject/formula, name + business + town, the time, e-mail
// (mailto, with a "reply" pill) and phone (tel), and the message as plain
// text.

// Messages longer than this start folded with a "Show more" link
export const MESSAGE_FOLD_LENGTH = 280;

export const contactReplyMailto = (item) =>
  `mailto:${mailtoAddress(item.email)}?subject=${encodeURIComponent(`Re: ${item.onderwerp || ''}`)}`;

export const telHref = (telefoon) => `tel:${String(telefoon).replace(/[^\d+ ]/g, '')}`;

const title = (item) => [item.onderwerp, item.formule].filter(Boolean).join(' – ') || 'Contact request';

const who = (item) => [item.naam, item.zaak, item.gemeente].filter(Boolean).join(' · ');

const Message = ({ text }) => {
  const [open, setOpen] = useState(false);
  const full = (text || '').trim();
  if (!full) return null;
  const long = full.length > MESSAGE_FOLD_LENGTH;
  const shown = long && !open ? `${full.slice(0, MESSAGE_FOLD_LENGTH).trimEnd()}…` : full;
  return (
    <div className="contact-message">
      {/* Visitor text: a React text node, never HTML */}
      <div className="contact-message-text">{shown}</div>
      {long && (
        <button type="button" className="request-link-button contact-message-toggle" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
          {open ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
};

export const ContactRequestContent = ({ item }) => (
  <>
    <h5 className="request-card-title">{title(item)}</h5>
    <p className="request-card-line">
      <span className="request-card-label">Requested at:</span>
      <span className="request-card-value">{`${who(item) || 'Unknown sender'}${item.taal ? ` (${item.taal})` : ''} (${formatTime(item.createdAt)})`}</span>
    </p>
    <p className="request-card-line">
      <span className="request-card-label">Requested by:</span>
      <span className="request-card-value">
        {item.email ? (
          <>
            <a className="request-link" href={contactReplyMailto(item)}>
              {item.email}
            </a>
            <a className="request-reply-pill" href={contactReplyMailto(item)}>
              reply
            </a>
          </>
        ) : (
          'Unknown'
        )}
        {item.telefoon && (
          <>
            {' · '}
            <a className="request-link" href={telHref(item.telefoon)}>
              {item.telefoon}
            </a>
          </>
        )}
      </span>
    </p>
    <Message text={item.bericht} />
  </>
);

const ContactRequestList = ({ status, onChanged, today }) => (
  <RequestDayList
    kind="contact"
    status={status}
    onChanged={onChanged}
    today={today}
    renderCard={(item) => ({ content: <ContactRequestContent item={item} />, aside: null })}
  />
);

export default ContactRequestList;
